import Keycloak, { KeycloakTokenParsed } from 'keycloak-js';
import { environment } from '../environment';
import { handleError } from '../errors';

const keycloak = new Keycloak({
  url: environment.authUrl,
  realm: 'sickservices',
  clientId: 'serviceportal',

});

export interface AuthUser {
  id: string;
  username: string;
  givenName?: string;
  familyName?: string;
  email?: string;
  locale?: string;
  ssuCode?: string;
  managedSsu?: string;
  roles: string[];
  sickEmployee: boolean;
}

export interface AuthUserDataDto extends KeycloakTokenParsed {
  name?: string;
  given_name?: string;
  family_name?: string;
  preferred_username?: string;
  y_CustomerName?: string;
  y_CustomerNumber?: string;
  ssu?: string;
  managedSsu?: string;
  locale?: string;
  email?: string;
  email_verified?: boolean;
  sick_employee?: boolean;
}

let userData: AuthUser = {
  id: '',
  username: '',
  roles: [],
  sickEmployee: false,
};

export async function initAuthentication(): Promise<void> {
  // TODO: Handle timeout error, when Keycloak is not available!
  await keycloak.init({
    onLoad: 'login-required',
    pkceMethod: 'S256',
    scope: 'openid profile email sick-employee', // regular_auth
  });

  const t: AuthUserDataDto | undefined = keycloak.tokenParsed;

  // user might not have any roles in serviceportal client
  const roles = t?.resource_access?.['serviceportal']?.roles ?? [];

  if (t) {
    userData = {
      id: t.sub ?? '',
      username: t.preferred_username ?? '',
      givenName: t.given_name,
      familyName: t.family_name,
      email: t.email,
      locale: t.locale,
      ssuCode: t.ssu,
      managedSsu: t.managedSsu,
      roles,
      sickEmployee: t.sick_employee ?? false,
    };
  }
}

export async function getAccessToken(): Promise<string> {
  try {
    await keycloak.updateToken(5);
  } catch (_error) {
    await keycloak.login();
  }

  if (!keycloak.token) {
    throw new Error('Failed to authenticate user');
  }
  return keycloak.token;
}

export function hasClientCreationRole(): boolean {
  return getUserData().roles.includes('client_managers');
}

export function hasTestUserManagerRole(): boolean {
  return getUserData().roles.includes('test_user_manager');
}

export function getUserData(): AuthUser {
  return userData;
}

export function login() {
  keycloak.login().catch(handleError);
}

export function logout() {
  keycloak.logout().catch(handleError);
}
